import Utils from "./Utils";

export default class FormValidator
{
    constructor(form, notificator, settings)
    {
        this.form = form;
        this.notify = notificator;
        this.settings = settings;
    }

    isFormValid()
    {
        for (let i = 0; i < this.settings.length; ++i)
        {
            const fieldInfo = this.settings[i];
            const input = this.getInput(fieldInfo);
            const val = fieldInfo.value ?? Utils.valInput(input);

            if (!this.ignoreField(val, fieldInfo))
            {
                if (!this.checkRequired(val, fieldInfo))
                {
                    this.notify("danger", (<>Field <b>{fieldInfo.label}</b> is required.</>));
                    window.scrollTo(0, input.scrollTop);
                    input.focus();
                    return false;
                }
                let result = this.checkOperators(val, fieldInfo)
                if (!result.isValid)
                {
                    this.notify("danger", result.message);
                    return false;
                }

                result = this.validateType(val, fieldInfo)
                if (!result.isValid)
                {
                    this.notify("danger", result.message);
                    return false;
                }
            }
        }
        return true;
    }

    ignoreField(val, field)
    {
        const obj = field.ignoreCondition;
        let ret = false;

        if (!!obj)
        {
            switch (obj.type)
            {
                case "check":
                    ret = !(this.form[obj.input].checked === obj.value);
                    break;
                case "select":
                    const select = this.form[obj.input];
                    if (obj.subType)
                    {
                        const selOpt = select.options[select.selectedIndex];
                        switch (obj.subType.type)
                        {
                            case "dataset":
                                ret = selOpt.dataset[obj.subType.property] === obj.value;
                                break;
                            default:
                                break;
                        }
                    } else
                    {
                        ret = !obj.negate ? select.value === obj.value : select.value !== obj.value;
                    }
                    break;
                default:
            }
        }
        return ret;
    }

    checkRequired(val, fieldInfo)
    {
        let type = fieldInfo.type ?? "text";
        let ret = true;

        if (fieldInfo.required)
        {
            switch (type)
            {
                case "check":
                    val = this.getInput(fieldInfo).checked;
                    ret = val !== (fieldInfo.noVal ?? null);
                    break;
                case "file":
                    val = !!val ? val : this.getInput(fieldInfo).dataset.hasFile;
                    ret = !(!val || val === (fieldInfo.noVal ?? "invalidValue"))
                    break;
                default:
                    ret = !(!val || val === (fieldInfo.noVal ?? "invalidValue"))
                    break;
            }
        }
        return ret;
    }

    checkOperators(val, field)
    {
        if (!field.conditions)
            return {isValid: true};

        let ret = false;
        let msg = "";

        for (let i = 0; i < field.conditions.length; ++i)
        {
            const cond = field.conditions[i];
            switch (cond.op)
            {
                case "gt":
                    ret = parseFloat(val) > parseFloat(cond.input ? this.form[cond.input].value : cond.value);
                    msg = (<>Field {field.label} must be greater than {cond.input ? cond.label : cond.value}</>);
                    break;
                case "lt":
                    ret = parseFloat(val) < parseFloat(cond.input ? this.form[cond.input].value : cond.value);
                    msg = (<>Field {field.label} must be lesser than {cond.input ? cond.label : cond.value}</>);
                    break;
                case "geq":
                    ret = parseFloat(val) >= parseFloat(cond.input ? this.form[cond.input].value : cond.value);
                    msg = (<>Field {field.label} must be greater or equal to {cond.input ? cond.label : cond.value}</>);
                    break;
                case "leq":
                    ret = parseFloat(val) <= parseFloat(cond.input ? this.form[cond.input].value : cond.value);
                    msg = (<>Field {field.label} must be lesser or equal to {cond.input ? cond.label : cond.value}</>);
                    break;
                case "eq":
                    ret = parseFloat(val) === parseFloat(cond.input ? this.form[cond.input].value : cond.value);
                    msg = (<>Field {field.label} must be equals to {cond.input ? cond.label : cond.value}</>);
                    break;
                default:
            }
            if (!ret)
                break;
        }

        return {isValid: ret, message: msg};
    }

    validateType(val, field)
    {
        if (!val)
            return {isValid: true};
        let type = field.type ?? "text";
        let ret = true;
        let message = "";

        switch (type)
        {
            case "phone":
                ret = /^[+0-9]{10,14}$/.test(val);
                message = (<>Field {field.label} must be a valid phone number</>);
                break;
            case "url":
                ret = /^((([htps]{4,5}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)$/.test(val);
                message = (<>Field {field.label} must be a website address (e.g. www.mycompany.com)</>);
                break;
            case "email":
                ret = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]{2,}$/.test(val);
                message = (<>Field {field.label} must be a valid email address</>);
                break;
            default:
                break;
        }
        return {isValid: ret, message: message};
    }

    getDTO()
    {
        const dto = {};
        this.settings.forEach(field =>
        {
            if (typeof field.isProperty === "undefined" || field.isProperty !== false)
            {
                let value = field.value ?? Utils.valInput(this.getInput(field));
                
                // Convert email to lowercase
                if (field.type === "email" && value) {
                    value = value.toLowerCase();
                }

                if (field.type !== "check")
                    dto[field.property] = Utils.deleteTags(value);
                else
                    dto[field.property] = this.getInput(field).checked;

                if (typeof field.defaultValue !== "undefined" && !dto[field.property])
                    dto[field.property] = Utils.deleteTags(field.defaultValue);
            }
        });
        return dto;
    }

    getInput(fieldInfo)
    {
        return this.form[fieldInfo.input ?? fieldInfo.property];
    }
}